import { cx } from "@jugl-web/utils";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";
import { PlainButton } from "../../../primitives";

export interface ControlBarButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled"> {
  label?: ReactNode;
  startSlot?: ReactNode;
  endSlot?: ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
}

export const ControlBarButton = forwardRef<
  HTMLButtonElement,
  ControlBarButtonProps
>(
  (
    { label, startSlot, endSlot, isActive, isDisabled, className, ...props },
    ref
  ) => (
    <PlainButton
      ref={ref}
      className={cx(
        "jugl__focusable-outline flex h-[40px] min-w-[40px] shrink-0 items-center justify-center gap-2 rounded-lg px-2 text-sm text-[#828282] transition-colors hover:bg-white",
        isActive && "bg-white",
        className
      )}
      disabled={isDisabled}
      {...props}
    >
      {startSlot}
      {label && (
        <span className="truncate font-secondary leading-[21px] font-normal text-dark-800">
          {label}
        </span>
      )}
      {endSlot}
    </PlainButton>
  )
);
